import View from '@shared/components/layout-default/layout-default-router-view';

const verification = [
  {
    path: 'verification',
    component: View,
    children: [
      {
        path: '',
        name: 'verification.index',
        redirect: {
          name: 'verification.trunk.index'
        }
      },

      {
        path: 'settings',
        name: 'verification.trunk.index',
        component: () =>
          import(
            /* webpackChunkName: 'verification' */
            '@verification/pages/trunks-list-page'
          ),
        meta: {
          title: {
            code: 'verification.breadcrumb.trunk.index'
          }
        }
      },

      {
        path: 'stats',
        component: View,
        children: [
          {
            path: '',
            name: 'verification.stats.index',
            redirect: {
              name: 'verification.stats.type',
              params: {
                type: 'general'
              }
            }
          }
          // {
          //   path: ':type(general|detailed)',
          //   name: 'verification.stats.type',
          //   component: () =>
          //     import(
          //       /* webpackChunkName: 'mailer-mailings' */
          //       '@mailer-mailings/pages/voice-stats-page'
          //     ),
          //   meta: {
          //     title: {
          //       code: 'shared.breadcrumb.stats.title'
          //     }
          //   }
          // }
        ]
      }
    ]
  }
];

export { verification };
